const getDisplayName = o => o.displayName || o.constructor.displayName || o.constructor.name;

export default getDisplayName;
